import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { Configuration } from '../../app.constants';
import {OrganizationService} from '../../shared/services/organization.service';
import { AuthService } from '../../shared/services/auth/auth.service'; 
import { ToastService } from '../../shared/services/toast.service';
import { Router} from '@angular/router';

@Component({
  selector: 'app-hr-team-pop-up',
  templateUrl: './hr-team-pop-up.component.html',
  styleUrls: ['./hr-team-pop-up.component.css']
})
export class HrTeamPopUpComponent implements OnInit {
  public associateMap;
  public hrTeamCompanies=  [];
  public selectedCompanies = [];
  public allOrganizations = [];
  public displaySelectedCompanies = [];
  public currentUserId;
  public associate: any;
  public associateImageUrl;
  public serverApiUrl;
  public imagePlaceholder = '';
  constructor(public dialogRef: MatDialogRef<HrTeamPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public organizationService: OrganizationService,
    public config: Configuration,
    public authService: AuthService,
    public toastService: ToastService,
    public router: Router ) {}
    
  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
    this.currentUserId = this.authService.user.associateId;
    if (this.data !== null) {
      this.associate = this.data.associate;
    }
    this.associateImageUrl = this.serverApiUrl + this.associate['personalInformation']['avatarUrl'];
    this.organizationService.getAssociatesCompaniesHrTeamMapping(this.data.associate._id).subscribe(responseRecieved => {
      this.associateMap = responseRecieved['associateMap'];
      this.allOrganizations = responseRecieved['organizations'];
      if (this.associateMap)  {
        this.associateMap.companies.forEach(element => {
          let tempOrdg =  {
            '_id': element['_id'][0],
            'company': {
              'companyName': element['companyName'][0],
              'companyId': element['companyId'][0]
            }
          };
          this.selectedCompanies.push(tempOrdg);
        });
        this.displaySelectedCompanies = Object.assign([],this.selectedCompanies); 
      }
      this.hrTeamCompanies = this.allOrganizations;
    }, error => {
      console.log('Response Recieved error', error);
    })
  }
  changeInCompanyMultiSelect(event) {
    if (event['isUserInput']) {
      let companyId = event['source']['value']['_id'];
      if (event['source']['_selected']) {
        this.organizationService.addInHrTeamCompany(this.data.associate._id,companyId).subscribe(data => {
          this.organizationService.getAssociatesCompaniesHrTeamMapping(this.data.associate._id).subscribe(resRecv => {
            this.selectedCompanies = [];
            this.associateMap = resRecv['associateMap'];
            this.allOrganizations = resRecv['organizations'];
            if (this.associateMap)  {
              this.associateMap.companies.forEach(element => {
                let tempOrdg =  {
                  '_id': element['_id'][0],
                  'company': {
                    'companyName': element['companyName'][0],
                    'companyId': element['companyId'][0]
                  }
                };
                this.selectedCompanies.push(tempOrdg);
              });
              this.displaySelectedCompanies = Object.assign([],this.selectedCompanies);
            }
            this.hrTeamCompanies = this.allOrganizations;
            this.toastService.success();
          },err1 => {
            this.toastService.error('Error while updating HR');
          });
        },err => {
          console.log(err);
          this.toastService.error('Could not update HR Team');
        });
      } else {
        this.organizationService.removenHrTeamCompany(this.data.associate._id,companyId).subscribe(data => {
          console.log('selected Companies',this.selectedCompanies);
          this.organizationService.getAssociatesCompaniesHrTeamMapping(this.data.associate._id).subscribe(resRecv => {
            this.selectedCompanies = [];
            this.associateMap = resRecv['associateMap'];
            this.allOrganizations = resRecv['organizations'];
            if (this.associateMap)  {
              this.associateMap.companies.forEach(element => {
                let tempOrdg =  {
                  '_id': element['_id'][0],
                  'company': {
                    'companyName': element['companyName'][0],
                    'companyId': element['companyId'][0]
                  }
                };
                this.selectedCompanies.push(tempOrdg);
              });
              this.displaySelectedCompanies = Object.assign([],this.selectedCompanies);
            }
            this.hrTeamCompanies = this.allOrganizations;
            this.toastService.success();
          },err1 => {
            this.toastService.error('Unable to add to HR Team');
          });
         
        },err => {
          console.log(err);
          this.toastService.error('Could not update HR Team');
        });
      }
    }
  }

  done() {
    this.dialogRef.close('Proceed');
  }

  compareFn(company1, company2) {
    return company1 && company2 ? company1._id === company2._id : company1 === company2;
  }
  routeTocompany(id) {
    this.done();
    this.router.navigate([`/home/organization/profile/view/${id}`]);
  }
}
